import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getState = createFeatureSelector<State>('organization');

export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getOrganization = createSelector(
  getState,
  (state: State) => state.data
);

